import classes from "./YooKassaPaymentStage.module.scss";
import { YooKassaStage } from "../../../../../common/types/enums";
import { useTheme } from "../../../../../common/hooks/useTheme";
import { useYooKassaPayment } from "../../hooks/useYooKassaPayment";
import { MdArrowBack, MdCheckCircle, MdError } from "react-icons/md";

type Props = {
  token: string;
  paymentId: string;
  onSuccess?: () => void;
  onError?: () => void;
  onBack?: () => void;
};

export const YooKassaPaymentStage = ({
  token,
  paymentId,
  onSuccess,
  onError,
  onBack,
}: Props) => {
  const { stage } = useYooKassaPayment(token, paymentId, {
    onSuccess,
    onError,
  });
  const { theme } = useTheme();

  if (stage === YooKassaStage.WIDGET) {
    return (
      <div className={classes.container}>
        <div
          className={classes.header}
          style={{ borderBottomColor: theme.border }}
        >
          <button
            className={classes.backButton}
            onClick={onBack}
            style={{ color: theme.text }}
          >
            <MdArrowBack size={24} />
          </button>
          <div className={classes.titleContainer}>
            <h2 className={classes.title} style={{ color: theme.text }}>
              Оплата заказа
            </h2>
            <p
              className={classes.subtitle}
              style={{ color: theme.textSecondary }}
            >
              Введите данные карты
            </p>
          </div>
        </div>

        <div className={classes.content}>
          <div
            className={classes.widgetContainer}
            style={{ backgroundColor: theme.card }}
          >
            <div id="payment_form" />
          </div>
        </div>
      </div>
    );
  }

  if (stage === YooKassaStage.SUCCESS) {
    return (
      <div className={classes.container}>
        <div
          className={classes.header}
          style={{ borderBottomColor: theme.border }}
        >
          <button
            className={classes.backButton}
            onClick={onBack}
            style={{ color: theme.text }}
          >
            <MdArrowBack size={24} />
          </button>
          <div className={classes.titleContainer}>
            <h2 className={classes.title} style={{ color: theme.text }}>
              Оплата заказа
            </h2>
          </div>
        </div>

        <div className={classes.content}>
          <div className={classes.messageContainer}>
            <div
              className={classes.successIcon}
              style={{ backgroundColor: theme.success }}
            >
              <MdCheckCircle size={48} color="#fff" />
            </div>
            <p className={classes.message} style={{ color: theme.text }}>
              Оплата прошла успешно
            </p>
            <p
              className={classes.subMessage}
              style={{ color: theme.textSecondary }}
            >
              Сейчас произойдет переход на страницу заказа
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (stage === YooKassaStage.ERROR) {
    return (
      <div className={classes.container}>
        <div
          className={classes.header}
          style={{ borderBottomColor: theme.border }}
        >
          <button
            className={classes.backButton}
            onClick={onBack}
            style={{ color: theme.text }}
          >
            <MdArrowBack size={24} />
          </button>
          <div className={classes.titleContainer}>
            <h2 className={classes.title} style={{ color: theme.text }}>
              Оплата заказа
            </h2>
          </div>
        </div>

        <div className={classes.content}>
          <div className={classes.messageContainer}>
            <div
              className={classes.errorIcon}
              style={{ backgroundColor: theme.danger }}
            >
              <MdError size={48} color="#fff" />
            </div>
            <p className={classes.message} style={{ color: theme.text }}>
              Оплата не прошла
            </p>
            <p
              className={classes.subMessage}
              style={{ color: theme.textSecondary }}
            >
              Попробуйте снова или выберите другой способ оплаты
            </p>
            <button
              className={classes.retryButton}
              style={{
                backgroundColor: theme.primary,
                color: "#ffffff",
              }}
              onClick={onBack}
            >
              Вернуться к заказу
            </button>
          </div>
        </div>
      </div>
    );
  }

  return null;
};